import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-1006"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M14.57 3.689s-6.977-2.06-9.323-2.672a.695.695 0 0 0-.836.497L1.028 14.121a.708.708 0 0 0 .476.847.71.71 0 0 0 .876-.485l1.462-5.45 10.829-4.214a.608.608 0 0 0-.101-1.13z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }